var ESLintTester = require("./eslint").RuleTester;

console.log("Use babel-eslint for test suite");
ESLintTester.setDefaultConfig({
    parser: "../../index"
});



//////////////////
// WEBPACK FOOTER
// ./~/babel-eslint/eslint-tester.js
// module id = 1006
// module chunks = 0